import React from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { useNavigate } from "react-router-dom";

const CARD_SX = {
  p: 2,
  height: "100%",
  borderRadius: 3,
  boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
  border: "1px solid #eef0f4",
};

export default function ResourceAllocationCard() {
  const nav = useNavigate();
  return (
    <Paper
      sx={{
        ...CARD_SX,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography variant="subtitle1" fontWeight={700} sx={{ color: "#111827" }}>Resource Allocation</Typography>
      <Typography variant="body2" sx={{ color: "#374151", fontWeight: 700, mt: 0.5, mb: 2 }}>
        Allocate worksheets and content to plan weeks
      </Typography>
      <Box sx={{ position: "relative", width: 140, height: 140, my: 1 }}>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            bgcolor: "#ede9fe",
          }}
        />
        <AssignmentTurnedInIcon
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: 64,
            color: "#7c3aed",
          }}
        />
      </Box>
      <Button
        variant="contained"
        onClick={() => nav("/admin/resource-allocation")}
        sx={{ mt: 2, bgcolor: "#7c3aed", textTransform: "none", fontWeight: 600, px: 3 }}
      >
        Manage all
      </Button>
    </Paper>
  );
}
